module.exports = __webpack_public_path__ + "media/images/product/f_p-6b5968600705b7bc9bf79500de0b1c89.png";